import '../styles.css';
import { prop } from '@ipfabric/utils/fp/prop';
import { GraphBreadcrumbContainer } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbContainer';
import type { GraphBreadcrumbProps } from 'components/Graph/GraphBreadcrumbs/GraphBreadcrumbProps';
import {
  BREADCRUMB_PATHLOOKUP_DEFAULT_GW,
  type GraphBreadcrumbType,
  type PathLookupInstanceBreadcrumb,
} from 'components/Graph/GraphBreadcrumbs/helpers/buildBreadcrumbs';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { loadEmptyGraph } from 'components/Graph/commands/loadEmptyGraph';
import { showSidePanel } from 'components/Graph/commands/showSidePanel';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';

const removedByRemoveButtonClick: GraphBreadcrumbType[] = [
  'compareMode',
  'intentCheck',
];

export const getPathLookupInstanceBreadcrumbText = (
  breadcrumb: PathLookupInstanceBreadcrumb,
  msg: AppTranslations,
): string =>
  `${
    breadcrumb.destination !== BREADCRUMB_PATHLOOKUP_DEFAULT_GW
      ? `${msg.canvasGraph.breadcrumbs.pathLookupInstance.source}: `
      : ''
  }
      ${breadcrumb.source}${breadcrumb.sourcePort !== null ? `:${breadcrumb.sourcePort}` : ''}
      ${
        breadcrumb.destination === BREADCRUMB_PATHLOOKUP_DEFAULT_GW
          ? msg.canvasGraph.breadcrumbs.pathLookupInstance.toDefaultGateway
          : `| ${
              msg.canvasGraph.breadcrumbs.pathLookupInstance.destination
            }: ${breadcrumb.destination}${
              breadcrumb.destinationPort !== null
                ? `:${breadcrumb.destinationPort}`
                : ''
            }`
      }`;

export const PathLookupInstanceBreadcrumbItem: FC<
  GraphBreadcrumbProps<PathLookupInstanceBreadcrumb>
> = (props) => {
  const msg = useLocale();

  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
  });

  return (
    <GraphBreadcrumbContainer
      containerStyle='default'
      onClick={() => {
        ctxProps.dispatch(showSidePanel, { pathLookupTabId: 'dataInput' });
      }}
      onIndicateRemoveOthers={props.onIndicateRemoveOthers}
      onRemoveButtonClick={() => {
        ctxProps.dispatch(loadEmptyGraph);
        ctxProps.dispatch(showSidePanel, { pathLookupTabId: 'dataInput' });
      }}
      removalIndicated={props.removalIndicated}
      removedByRemoveButtonClick={removedByRemoveButtonClick}
    >
      {getPathLookupInstanceBreadcrumbText(props.content, msg)}
    </GraphBreadcrumbContainer>
  );
};
